import { render, staticRenderFns } from "./FakturPajakDetail.vue?vue&type=template&id=455bda46&scoped=true"
import script from "./FakturPajakDetail.vue?vue&type=script&lang=js"
export * from "./FakturPajakDetail.vue?vue&type=script&lang=js"
import style0 from "./FakturPajakDetail.vue?vue&type=style&index=0&id=455bda46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455bda46",
  null
  
)

export default component.exports